// ------------------------------------
// Imports
// ------------------------------------
import {
  updateUserEmailApi,
  updateUserPasswordApi,
  deleteUserApi
} from 'api/account';
import {
  changeEmail,
  changePassword,
  deleteAccountSuccess
} from 'libs/cleverTap';
import { updateUserEmail } from './auth';
import { notify } from './notice';
// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_ACCOUNT_START = 'UPDATE_ACCOUNT_START';
export const UPDATE_ACCOUNT_END = 'UPDATE_ACCOUNT_END';
export const DELETE_ACCOUNT_START = 'DELETE_ACCOUNT_START';
export const DELETE_ACCOUNT_END = 'DELETE_ACCOUNT_END';

const UPDATE_USER_API_MAP = {
  email: updateUserEmailApi,
  password: updateUserPasswordApi
};

// ------------------------------------
// Actions
// ------------------------------------
export function updateAccountStart() {
  return ({ type: UPDATE_ACCOUNT_START });
}

export function updateAccountEnd() {
  return ({ type: UPDATE_ACCOUNT_END });
}

export function updateAccountUser(valueObject, keyToUpdate, cb = () => {}) {
  return (dispatch, getState) => {
    const { account: { isFetching } } = getState();
    if (!isFetching) {
      dispatch(updateAccountStart());
      // get required function from map to update concerned user key
      UPDATE_USER_API_MAP[keyToUpdate](valueObject)
        .then((res) => {
          // Check which field is changed
          if (keyToUpdate === 'email') {
            dispatch(updateUserEmail(valueObject));
            // Push change_email event into clevertap
            changeEmail();
          } else {
            // Push change_password event into clevertap
            changePassword();
          }
          cb();
          dispatch(updateAccountEnd());
        })
        .catch((error) => {
          dispatch(notify({ error }));
          dispatch(updateAccountEnd());
        });
    }
  };
}

export function deleteAccountStart() {
  return ({ type: DELETE_ACCOUNT_START });
}

export function deleteAccountEnd() {
  return ({ type: DELETE_ACCOUNT_END });
}

export function deleteAccountUser() {
  return (dispatch) => {
    dispatch(deleteAccountStart());
    deleteUserApi()
      .then((res) => {
        if (res.statusCode === 200) {
          // Push delete_account event into cleverTap
          deleteAccountSuccess();
          dispatch(deleteAccountEnd());
        }
      })
      .catch((error) => {
        dispatch(notify({ error }));
        dispatch(deleteAccountEnd());
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/account.js